module.exports = __webpack_public_path__ + "static/img/banner_desktop2.afe8918d.jpg";